import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/function-component-definition */
import styled from 'styled-components';
// old design
const Wrapper = styled.div `
  margin: auto auto;
  //padding: 45px 106px 0 106px;
  width: 99vw;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: auto;
`;
export const DataContainer = ({ children }) => _jsx(Wrapper, { children: children });
// new design
export const DataContainerNew = styled.div `
  margin: auto auto;
  position: relative;
  padding: 60px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: auto;
  background-attachment: fixed;
  background-size: cover;
  background-position: top;
  min-height: 100vh;
`;
